// Refrescar sin cerrar la app.
//
// Cada tarjeta pide sus datos al montarse y luego cada X minutos. Faltaba lo
// obvio: que la persona pueda decir «tráemelo otra vez, ahora». Hasta hoy la
// única forma era cerrar la app y volver a abrirla.
//
// Esto es un contador con suscriptores, no un contexto de React: así lo puede
// leer cualquier tarjeta sin envolver el árbol entero, y un tirón hacia abajo
// refresca TODAS a la vez en lugar de una.
type Oyente = (n: number) => void;

let n = 0;
const oyentes = new Set<Oyente>();

/** Un tirón hacia abajo: todas las tarjetas vuelven a pedir sus datos. */
export function refrescarTodo() {
  n += 1;
  oyentes.forEach((f) => f(n));
}

export function suscribir(f: Oyente): () => void {
  oyentes.add(f);
  return () => oyentes.delete(f);
}

export const valorActual = () => n;
